import {
  IPackageRuleset,
  IPackageRulesetCreateRequest,
  IPackageRulesetUpdateRequest,
} from "types/PackageRuleset/PackageRuleset";
import {
  IAllPackageRulesetResponse,
  IPackageRulesetResponse,
} from "types/PackageRuleset/PackageRulesetResponse";

import { api } from ".";

const packageRulesetQueries = api.injectEndpoints({
  endpoints: (builder) => ({
    getAllPackageRulesets: builder.query<
      IAllPackageRulesetResponse,
      null | void
    >({
      query: () => "package-rulesets/all",
    }),
    getPackageRulesetById: builder.query<
      IPackageRulesetResponse,
      string | undefined
    >({
      query: (id: string) => `package-rulesets/${id}`,
    }),
    createPackageRuleset: builder.mutation<
      IPackageRuleset,
      IPackageRulesetCreateRequest
    >({
      query: (newRuleset) => ({
        url: "package-rulesets",
        method: "POST",
        body: newRuleset,
      }),
    }),
    updatePackageRuleset: builder.mutation<
      IPackageRuleset,
      IPackageRulesetUpdateRequest
    >({
      query: (updatedRuleset) => ({
        url: `package-rulesets/${updatedRuleset.id}`,
        method: "PUT",
        body: updatedRuleset,
      }),
    }),
    deletePackageRuleset: builder.mutation<any, string>({
      query: (id) => ({
        url: `package-rulesets/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetAllPackageRulesetsQuery,
  useGetPackageRulesetByIdQuery,
  useCreatePackageRulesetMutation,
  useUpdatePackageRulesetMutation,
  useDeletePackageRulesetMutation,
} = packageRulesetQueries;
